import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useAppSelector } from '../redux/store';
import { assertUnreachable } from '../utils/tsUtils';
import { EntryScene } from './entry/entryScene';
import { LoadingScene } from './loading/loadingScene';
import { LobbyScene } from './lobby/lobbyScene';
import { MttStagingScene } from './mttStaging/mttStagingScene';
import { PokerScene } from './poker/pokerScene';
import { ReverifyScene } from './reverify/reverifyScene';
import { RoomToLobbyTransitionScene } from './transitions/roomToLobbyTransitionScene';
import { RoomToRoomTransitionScene } from './transitions/roomToRoomTransitionScene';
export const SceneRouter = () => {
    const sceneType = useAppSelector((state) => state.scene.sceneType);
    switch (sceneType) {
        case 'entry': {
            return _jsx(EntryScene, {});
        }
        case 'reverify': {
            return _jsx(ReverifyScene, {});
        }
        case 'loading': {
            return _jsx(LoadingScene, {});
        }
        case 'lobby': {
            return _jsx(LobbyScene, {});
        }
        case 'poker': {
            return _jsx(PokerScene, {});
        }
        case 'mttStaging': {
            return _jsx(MttStagingScene, {});
        }
        case 'roomToLobby': {
            return _jsx(RoomToLobbyTransitionScene, {});
        }
        case 'roomToPoker': {
            return _jsx(RoomToRoomTransitionScene, { toRoomSceneType: 'poker' });
        }
        case 'roomToMttStaging': {
            return _jsx(RoomToRoomTransitionScene, { toRoomSceneType: 'mttStaging' });
        }
        default: {
            assertUnreachable(sceneType);
        }
    }
};
